/**
 * @desc pms-判断供应商是否处于审批中
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.RcpCheckSupplierStatus, options?: any) {
  return updateResponse(
    http(URL + `/srm/checkSupplierStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
